import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

interface GeneralPerformancePageTitleSignature {
  Args: {
    count?: number | null;
    dataTestId?: string;
    title: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const GeneralPerformancePageTitle: TOC<GeneralPerformancePageTitleSignature> =
  <template>
    <div class="flex items-center gap-200" ...attributes>
      <h2 class="text-neutral-emphasis">{{@title}}</h2>

      {{#if @count}}
        <span class="text-300--regular" data-test-id={{@dataTestId}}>
          {{t "general.hotel.count" count=@count}}
        </span>
      {{/if}}

      {{yield}}
    </div>
  </template>;

export default GeneralPerformancePageTitle;
